/**
 * Schema for `GET /healthz` (apps/api/src/routes/health.ts).
 *
 * Both ends of the wire — the API that emits this shape and the SPA that
 * consumes it — import from here. Any change to the response contract
 * must happen in this file first; the type-checker catches the rest.
 */

import { z } from 'zod';

export const HealthRuntimeModeSchema = z.enum(['development', 'staging', 'production']);

export const HealthResponseSchema = z.object({
  status: z.literal('ok'),
  version: z.string().min(1),
  mode: HealthRuntimeModeSchema,
  timestamp: z.iso.datetime(),
  requestId: z.string().min(1),
});

export type HealthResponse = z.infer<typeof HealthResponseSchema>;
export type HealthRuntimeMode = z.infer<typeof HealthRuntimeModeSchema>;
